import { useMantineTheme } from "@mantine/core";

interface IProcessingCircleProps {
  text?: string;
  color?: string;
}

export const ProcessingCircle = (props: IProcessingCircleProps) => {
  const theme = useMantineTheme();

  return (
    <>
      <div
        className="spinner"
        style={{
          marginRight: "8px",
          borderTop: `4px solid ${props.color || theme.colors.darkBlue[0]}`,
          borderBottom: "4px solid transparent",
          borderLeft: "4px solid transparent",
          borderRight: "4px solid transparent"
        }}
      ></div>
      {props.text}
    </>
  );
};
